














































































import { Component, Vue } from 'vue-property-decorator'
import AcceptanceService from '@/services/AcceptanceService'

let isFetchingAcceptanceFromRouteGuard = false

@Component
export default class TermsAcceptance extends Vue {
  isAccepted: boolean = false
  updatedPolicyVersion: boolean = false
  updatedTermVersion: boolean = false
  isChecked: boolean = false
  term_url: string = process.env.VUE_APP_TERM_URL as string || ''
  term_version: string = ''
  policy_url: string = process.env.VUE_APP_POLICY_URL as string || ''
  policy_version: string = ''
  modalMess: string = ''
  loading: boolean = true

  get agreementText(): string {
    const terms = this.$t('acceptance.terms_of_use') as string
    const policy = this.$t('acceptance.privacy_policy') as string

    if (this.updatedTermVersion && this.updatedPolicyVersion) {
      return this.$t('acceptance.agree_both', { terms, policy }) as string
    }

    if (this.updatedTermVersion) {
      return this.$t('acceptance.agree_terms_only', { terms }) as string
    }

    if (this.updatedPolicyVersion) {
      return this.$t('acceptance.agree_policy_only', { policy }) as string
    }

    return ''
  }

  created() {
    // Fallback for edge cases where route guard does not run.
    if (!isFetchingAcceptanceFromRouteGuard) {
      this.initAcceptanceStatus()
    }
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    isFetchingAcceptanceFromRouteGuard = true
    AcceptanceService.getAcceptance()
      .then((response) => {
        const status = response.data.status

        if (!status.needs_acceptance) {
          localStorage.removeItem('needs_acceptance')
          next({ name: 'home' })
          return
        }

        localStorage.setItem('needs_acceptance', 'true')
        next((vm: Vue) => {
          ;(vm as TermsAcceptance).setAcceptanceStatus(status)
        })
      })
      .catch((error) => {
        console.log(error)
        next({ name: 'home' })
      })
      .finally(() => {
        isFetchingAcceptanceFromRouteGuard = false
      })
  }

  initAcceptanceStatus() {
    this.loading = true
    AcceptanceService.getAcceptance()
      .then((response) => {
        const status = response.data.status

        if (!status.needs_acceptance) {
          localStorage.removeItem('needs_acceptance')
          this.loading = false
          this.$router.replace({ name: 'home' })
          return
        }

        localStorage.setItem('needs_acceptance', 'true')
        this.setAcceptanceStatus(status)
      })
      .catch((error) => {
        console.log(error)
        this.loading = false
        this.$router.replace({ name: 'home' })
      })
  }

  setAcceptanceStatus(status: any) {
    this.isAccepted = status.has_previously_accepted
    this.term_url = status.term_url
    this.policy_url = status.policy_url
    this.updatedTermVersion = status.updated_term_version
    this.updatedPolicyVersion = status.updated_policy_version

    localStorage.setItem('is_accepted', this.isAccepted.toString())
    localStorage.setItem('updated_term_version', this.updatedTermVersion.toString())
    localStorage.setItem('updated_policy_version', this.updatedPolicyVersion.toString())
    localStorage.setItem('term_url', this.term_url)
    localStorage.setItem('policy_url', this.policy_url)
    this.loading = false
  }

  submitAcceptance() {
    if (this.isChecked) {
      let params: {term_url?: string; policy_url?: string} = {}

      if (this.updatedTermVersion) {
        params.term_url = this.term_url
      }

      if (this.updatedPolicyVersion) {
        params.policy_url = this.policy_url
      }

      AcceptanceService.Acceptance(params).then((response) => {        
        localStorage.removeItem('is_accepted')
        localStorage.removeItem('updated_term_version')
        localStorage.removeItem('updated_policy_version')
        localStorage.removeItem("needs_acceptance");
        localStorage.removeItem('term_version')
        localStorage.removeItem('policy_version')
        localStorage.removeItem('term_url')
        localStorage.removeItem('policy_url')

        this.$bvModal.show('modal-success-acceptance');
      }).catch((error) => {
        this.modalMess = error.response?.data?.message;
        if (error.response.status == 422) {
          this.modalMess = this.$t('acceptance.message_error_when_new_update') as string;  
        }

        this.$bvModal.show('modal-error-acceptance');
      })
    }
  }
}
